<template>
  <section class="is-fullwidth home-background p-4">
    <div id="container-banner" style="height: 100%;">
        <div class="is-flex is-flex-direction-column is-align-items-center">
            <img src="@/assets/image/home/vet.png" alt="Doggy" class="doggy-img" />
            <img src="@/assets/image/home/doggy.png" alt="Doggy" class="doggy-img" />
        </div>
        <div>
            <h1 class="is-size-1 has-text-light is-hidden-mobile">¡HOLA!</h1>
            <p class="has-text-white pb-3 is-hidden-mobile has-text-justified" style="max-width: 450px; font-size: .95rem;">
                <strong class="has-text-light">VetSolutions</strong> es un software avanzado, diseñado específicamente para satisfacer las necesidades de los profesionales veterinarios y clínicas veterinarias.
                <span style="display: block;">Su plataforma intuitiva ofrece un conjunto completo de herramientas que facilitan la gestión administrativa, médica y financiera de los centros de salud animal.</span>
            </p>

            <div class="my-5">
                <el-button class="btn-register"  @click="goTo('register')">Regístrate</el-button>
                <el-button class="btn-primary" @click="goTo('login')">Ingresar</el-button>
            </div>

            <SocialMedia />

            <p class="has-text-white pt-5 help">Todos los derechos reservados a VetSolutions.</p>
        </div>
    </div>
    
  </section>
</template>

<script setup>
import { useRouter } from 'vue-router';
import SocialMedia from './SocialMedia.vue';

const router = useRouter();

const goTo = (name) => {
  router.push({ name });
}
</script>

<style scoped>
    .home-background {
        background-image: url('@/assets/image/home/banner2.png');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        position: relative;
        min-height: 750px;
        height: 100vh;
        font-family: sans-serif;
    }
    #container-banner{
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        align-content: center;
        gap: 4rem;
    }
    

    @media (max-width: 768px) {
        .home-background {
            height: auto;
            min-height: 100vh;
        }
        #container-banner{
            padding-top: 5rem;
            padding-bottom: 5rem;
            flex-direction: column;
            justify-content: center;
            text-align: center;
            gap: 2rem;
        }
        .doggy-img{
            width: 150px;
        }
        #container-banner > div:nth-child(2) {
            display: flex;
            flex-direction: column;
            align-items: center;
        }
    }
</style>
  